/* eslint-env browser, es6 */
import m from "mithril";

interface CopyPasteModel {
  duelId: string;
  linkCopied: boolean;
}

interface CopyPasteViewAttrs {
  duelId: string;
}

export class CopyPasteView implements m.Component<CopyPasteViewAttrs> {
  private model: CopyPasteModel;
  private controller: CopyPasteViewController;

  constructor(vnode: m.Vnode<CopyPasteViewAttrs>) {
    this.model = { duelId: vnode.attrs.duelId, linkCopied: false };
    this.controller = new CopyPasteViewController(
      this.model,
      ".copy-paste input"
    );
  }

  view(): m.Children {
    return m("div.copy-paste-wrapper", [
      m(
        "p.two-player-instructions",
        "Copy the link below and send to up to 5 friends."
      ),
      m("div.copy-paste", [
        m("input", {
          readonly: true,
          value: `https://iafisher.com/webble/p/${this.model.duelId}`,
        }),
        m(
          "span",
          {
            onclick: () => this.controller.copyToClipboard(),
          },
          [m(CopyPasteSvgView)]
        ),
      ]),
      this.model.linkCopied ? m("p.link-copied", "Link copied!") : null,
    ]);
  }
}

export class CopyPasteViewController {
  private model: CopyPasteModel;
  private inputCssSelector: string;

  constructor(model: CopyPasteModel, inputCssSelector: string) {
    this.model = model;
    this.inputCssSelector = inputCssSelector;
  }

  copyToClipboard() {
    const input = <HTMLInputElement>(
      document.querySelector(this.inputCssSelector)
    );
    input.focus();
    input.select();
    document.execCommand("copy");
    this.model.linkCopied = true;
  }
}

class CopyPasteSvgView implements m.Component {
  // @license
  //
  // SVG courtesy of Mono Icons
  //
  // The MIT License (MIT) Copyright 2020 Mono Company BV
  //
  // This license pertains to the Mono Icon Font, the software, as described on
  // http://icons.mono.company, NOT to any content created with the Mono Icon
  // Font.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the "Software"),
  // to deal in the Software without restriction, including without limitation
  // the rights to use, copy, modify, merge, publish, distribute, sublicense,
  // and/or sell copies of the Software, and to permit persons to whom the
  // Software is furnished to do so, subject to the following conditions:
  //
  // The above copyright notice and this permission notice shall be included in
  // all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
  // THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
  // FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
  // DEALINGS IN THE SOFTWARE.

  view(): m.Children {
    return m(
      "svg",
      {
        fill: "none",
        viewBox: "0 0 24 24",
        height: "24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
      },
      [
        m("path", {
          xmlns: "http://www.w3.org/2000/svg",
          d: "M2 4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V16H4C2.89543 16 2 15.1046 2 14V4ZM10 16V20H20V10H16V14C16 15.1046 15.1046 16 14 16H10ZM14 14V4L4 4V14H14Z",
          fill: "#656d76",
        }),
      ]
    );
  }
}
